import type { BasePagingResponse } from "../../../lib/api-contract";
import { apiUtils } from "../../../utils/apiUtils";
import type {
  CreateNotificationRequest,
  CreateNotificationResponse,
  DeleteNotificationResponse,
  GetNotificationStatisticsRequest,
  NotificationDetailResponse,
  NotificationItem,
  NotificationItemResponse,
  NotificationListRequest,
  NotificationStatisticResponse,
  UpdateNotificationRequest,
  UpdateNotificationResponse,
} from "../types/notification.types";

export async function getNotificationList(
  request: NotificationListRequest,
  signal?: AbortSignal,
): Promise<BasePagingResponse<NotificationItem>> {
  return apiUtils.getData<BasePagingResponse<NotificationItem>>(
    "/v1/portal/notification",
    "Failed to fetch notifications",
    {
      params: {
        alert_type_id: request.alert_type_id || undefined,
        keyword: request.keyword?.trim() || undefined,
        pin_status: request.pin_status || undefined,
        from: request.from || undefined,
        to: request.to || undefined,
        title: request.title?.trim() || undefined,
        content: request.content?.trim() || undefined,
        index: request.index,
        size: request.size,
        sort_key: request.sort_key,
        sort_direction: request.sort_direction,
      },
      signal,
    },
  );
}

export async function getNotificationDetail(
  id: string,
  signal?: AbortSignal,
): Promise<NotificationDetailResponse> {
  const data = await apiUtils.getData<NotificationDetailResponse>(
    `/v1/portal/notification/${id}`,
    "Failed to fetch notification",
    { signal },
  );
  return data;
}

export function getStatisticsNotification(
  request: GetNotificationStatisticsRequest,
  signal?: AbortSignal,
): Promise<NotificationStatisticResponse> {
  return apiUtils.getData<NotificationStatisticResponse>(
    "/v1/portal/notification/statistics",
    "Failed to fetch notification statistics",
    { params: request, signal },
  );
}

export async function createNotification(
  request: CreateNotificationRequest,
): Promise<CreateNotificationResponse> {
  return apiUtils.post<NotificationItemResponse, CreateNotificationRequest>(
    "/v1/portal/notification",
    request,
  );
}

export async function deleteNotification(id: string): Promise<DeleteNotificationResponse> {
  return apiUtils.delete<NotificationItemResponse | null>(`/v1/portal/notification/${id}`);
}

export async function updateNotification(
  id: string,
  request: UpdateNotificationRequest,
): Promise<UpdateNotificationResponse> {
  return apiUtils.put<NotificationItemResponse, UpdateNotificationRequest>(
    `/v1/portal/notification/${id}`,
    request,
  );
}
